/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-trailing-spaces */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import {
  Form,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  Platform,
} from '@ionic/angular';
import { UserApiService } from '../services/user-api.service';
import { LocalStorageService } from '../services/core/local-storage.service';
import { GlobalVariable } from '../global';
import { IonDatetime } from '@ionic/angular';
import { format, parseISO } from 'date-fns';
import { DateTimePage } from '../models/date-time/date-time.page';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { AuthRedirectServiceService } from '../services/navigationAuth/auth-redirect-service.service';

interface signupData {
  email: String;
  password: String;
}
@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.page.html',
  styleUrls: ['./sign-up.page.scss'],
})
export class SignUpPage implements OnInit {
  @ViewChild(IonDatetime, { static: true }) datetime: IonDatetime;
  @ViewChild('captchaRef') captchaRef: any;
  // isActiveNotif=true
  signUpData: signupData;
  signUpForm: FormGroup;
  isSubmitted = false;
  isChecked = false;
  isCheckedPrivacy = false;
  birthday;
  loading;
  formatedPhone: string;
  hideCap: boolean = false;
  PassType = 'password';
  private captchaPassed: boolean = false;
  private captchaResponse: string;
  isMobile = false;
  
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private signupApi: UserApiService,
    private localStorageService: LocalStorageService,
    public globals: GlobalVariable,
    private navCtrl: NavController,
    private nativeStorage: NativeStorage,
    private zone: NgZone,
    private modalController: ModalController,
    private platform: Platform,
  private authRedirectService: AuthRedirectServiceService) {
    this.signUpData = {} as signupData;
    
  }


  isActive = true;
  ngOnInit() {
    if (this.platform.is('mobile')) {
      this.isMobile = true;
    } else if (this.platform.is('desktop')) {
      this.isMobile = false;
    }
    this.signUpForm = this.fb.group({
      firstname: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern('[a-zA-Z ]*'),
      ]),
      lastname: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern('[a-zA-Z ]*'),
      ]),
      email: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/),
        ])
      ),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
      ]),
      phone: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(16),
          Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/),
        ])
      ),
    });
    console.log(this.signUpData);
  }

  switch() {
    if (this.isActive == false) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
  }
  numberChange() {
    console.log('here');
    this.formatedPhone = String(this.signUpForm.value.phone);
    var cleaned = ('' + this.formatedPhone).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      this.formatedPhone =
        '(' + match[1] + ') ' + (match[2] ? match[2] + '-' : '') + match[3];
      console.log(this.formatedPhone);
    }
    return null;
  }
  confirm() {
    this.datetime.confirm();
  }

  reset() {
    this.datetime.reset();
  }

  formatDate(value: string) {
    return format(parseISO(value), 'MMM dd yyyy');
  }
  async selectDate() {
    const modal = await this.modalController.create({
      component: DateTimePage,
      cssClass: 'dateModal',
    });
    await modal.present();
    modal.onDidDismiss().then((res) => {
      console.log(res);
      if (res.data.date) {
        this.birthday = res.data.date;
      }
    });
  }

  async signUp() {
    var cleaned = ('' + this.signUpForm.value.phone).replace(/\D/g, '');
    let cleanEmail = this.signUpForm.value.email.trim();
    this.signUpForm.get('email').setValue(cleanEmail);
    this.isSubmitted = true;
  
    if (!this.signUpForm.valid) {
      console.log('Please provide all the required values!');
      return false;
    }
    if (this.captchaPassed || this.captchaResponse != undefined) {
      if (this.isChecked == true && this.isCheckedPrivacy == true) {
        this.hideCap = true;
  
        // Show loading indicator
        await this.pageLoading();
  
        this.signupApi.customerSignUp(
          this.captchaResponse,
          this.signUpForm.value.firstname,
          this.signUpForm.value.lastname,
          this.signUpForm.value.email,
          this.signUpForm.value.password,
          '+1' + cleaned
        )
        .subscribe(
          async (data) => {
            this.hideCap = false;
            if (this.loading) {
              await this.loading.dismiss();
            }
  
            if (data.status != 'error') {
              this.globals.isloggedIn = false;
                this.localStorageService.setLogin(
                  'isLogin',
                  JSON.stringify(true)
                );
                this.localStorageService.setBusinessId(
                  'BusinessId',
                  data.customer_data.business_id
                );
                this.localStorageService.setQrText(
                  'QrText',
                  data.customer_data.qr_text
                );
                this.localStorageService.setUdId(
                  'UdId',
                  data.customer_data.udid
                );
                this.globals.udid = data.customer_data.udid;
                this.localStorageService.setUrl('Url', data.customer_data.qr);
                this.localStorageService.setProfileComplete(
                  'ProfileComplete',
                  data.customer_data.profile_complete
                );
                this.localStorageService.setPhoneVerified(
                  'PhoneVerified',
                  data.customer_data.phone_verified
                );
                this.localStorageService.setPhone(
                  'Phone',
                  data.customer_data.phone
                );
                this.localStorageService.setId('Id', data.customer_data.id);
                this.localStorageService.setLastName(
                  'LastName',
                  data.customer_data.last_name
                );
                this.localStorageService.setFirstName(
                  'FirstName',
                  data.customer_data.first_name
                );
                this.localStorageService.setEmail(
                  'Email',
                  data.customer_data.email
                );
                this.localStorageService.setDateJoined(
                  'DateJoined',
                  data.customer_data.date_joined
                );
                this.localStorageService.setCustomerType(
                  'CustomerType',
                  data.customer_data.customer_type
                );
                this.localStorageService.setBirthday(
                  'Birthday',
                  data.customer_data.birthday
                );
                this.nativeStorage.setItem('user', {
                  email: data.customer_data.email,
                  udid: data.customer_data.udid,
                  firstName: data.customer_data.first_name,
                  lastName: data.customer_data.last_name,
                  phone: data.customer_data.phone,
                  image: data.customer_data.url,
                  ID: data.customer_data.id,
                  date: data.customer_data.date_joined,
                  phone_verify: data.customer_data.phone_verified,
                  birthday: data.customer_data.birthday,
                  aniversary: data.customer_data.anniversary,
                });
                if (this.globals.guestLogin == true) {
                  this.globals.guestLogin = false;
                  this.globals.itemsInCart = [];
                }

                const redirect = this.authRedirectService.getRedirectUrl();
                if (redirect) {
                  this.router.navigate([redirect], { replaceUrl: true });
                } else {
                  this.navCtrl.navigateRoot('/order'); // default post-login page
                }


              // this.navCtrl.navigateRoot('/order');


            } else {
              console.log('errortesting',data.description);
              grecaptcha.reset();
              this.globals.presentToast(data.description, 'middle');
              this.captchaPassed = false;
              this.captchaResponse = null;
            }
          },
          async (error) => {
            console.log(error);
            this.captchaPassed = false;
            this.captchaResponse = null;
            grecaptcha.reset();
            const alert = await this.alertCtrl.create({
              header: 'Error',
              message: 'No response from server. Check internet connection.',
              buttons: ['OK'],
            });
            await alert.present();
            if (this.loading) {
              await this.loading.dismiss();
            }
          }
        );
      }
    } else {
      this.globals.presentToast('Verify Captcha', 'middle');
    }
  }
  get errorControl() {
    return this.signUpForm.controls;
  }
  checkEvent() {
    if (this.isChecked == false) {
      this.isChecked = true;
    } else {
      this.isChecked = false;
    }

    console.log(this.isChecked);
  }
  checkPrivacyAgreement() {
    if (this.isCheckedPrivacy == false) {
      this.isCheckedPrivacy = true;
    } else {
      this.isCheckedPrivacy = false;
    }

    console.log(this.isCheckedPrivacy);
  }
  openPrivacy() {
    this.router.navigate(['privacy-policy']);
    this.modalController.dismiss();

    // this.modal
  }
  terms() {
    this.router.navigate(['terms-conditions']);
    this.modalController.dismiss();

    // this.modal
  }
  async pageLoading() {
    this.loading = await this.loadingCtrl.create({
      message: '<img src="assets/animation/loader2.svg" alt="loading...">',
      cssClass: 'custom_loading',
    });
    await this.loading.present();
  }
  togglePassword() {
    console.log('toggle');
    this.PassType = (<HTMLInputElement>document.getElementById('pass')).type;

    if (this.PassType === 'password') {
      console.log('toggle', this.PassType);

      this.PassType = 'text';
      (<HTMLInputElement>document.getElementById('pass')).type = this.PassType;
    } else {
      this.PassType = 'password';
      (<HTMLInputElement>document.getElementById('pass')).type = this.PassType;
      console.log('toggle', this.PassType);
    }
  }

  close() {
    this.navCtrl.back();
  }

  captchaResolved(response: string): void {
      this.zone.run(() => {
        this.captchaPassed = true;
        this.captchaResponse = response;
      });
    
   
  }

  trimSpaces(callFrom: any) {
    if (callFrom == 0) {
      let val = this.signUpForm.value.firstname.trimStart();
      this.signUpForm.get('firstname').setValue(val);
    } else {
      let val = this.signUpForm.value.lastname.trimStart();
      this.signUpForm.get('lastname').setValue(val);
    }
  }

}
